export default "__VITE_ASSET__eCn8IB4h__"